<template>
 
<div> 

  <v-layout justify-center :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'">
    <v-card class="mt-10 m4u_tertiary"  :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'">
      <div v-if="editMemory === false">
      <v-card class="mx-auto m4u_tertiary"
        >
    <v-progress-linear
    v-if="progressOn"
      indeterminate
      color="teal"
    ></v-progress-linear>
      <!-- START OF MEDIA GALLERY -->
          <v-row wrap >
      <div v-for="media in medialocs" :key="media.MediaID" class="GalleryDiv"  >


            <div v-if="editMemory === false" >
      <MediaCard :mediaLocs="media.MediaLoc" :mediatype="media.MediaType" :mediaUser="user.UserID" :mediaFeature="media.FeatureMedia" :edit='false' @reloadMedia="resetMedia()"/>
        </div>

      </div>

          </v-row>

          <v-card-text class="m4u_text--text m4u_tertiary pr-4 ">

              <h2 >{{storyData.StoryTitle}} <span v-if="storyData.Hidden === 1">*</span></h2>
              <div >
                <v-card-subtitle v-if="toggle_exclusive === 3" class="m4u_text--text mt-2">Ingredients:</v-card-subtitle>
                <pre v-if="toggle_exclusive === 3">{{storyData.StoryIngredients}}</pre>
                <v-divider v-if="toggle_exclusive === 3"></v-divider>
                <v-card-subtitle v-if="toggle_exclusive === 3">Directions:</v-card-subtitle>
                <pre>{{storyData.StoryText}}</pre> <BR />
                </div>
          </v-card-text>

          <div v-for="comment in comments" :key="comment.CommentID" class="commentCard">
         <v-card  class="m4u_text--text ml-6 mr-6 mb-2 message_background">
           <div class="m4u_text--text">
            <h4> {{comment.UserDisplayName}} <span>, {{comment.CommentDate}}</span></h4>
           </div>
           <v-card-text class="m4u_text--text">
             {{comment.CommentText}}
           </v-card-text>
           <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn icon fab @click="deleteComment(comment.CommentID)" v-if="comment.UserID === user.UserID"><v-icon class="m4u_text--text">mdi-delete-outline</v-icon></v-btn>
           </v-card-actions>
         </v-card>
               </div>

      </v-card>

      </div>

  <v-card-text>
  
<!-- START OF UPLOADING FILES -->
<!-- BEGINNING OF edit DIALOG -->
<!--DIALOG FOR DRAFTS -->
      <v-dialog
      v-model="draft"
      fullscreen
      persistent
      max-width="290"
    >
      <v-card>
      
          <h2 class="m4u_text--text">You didn't add a circle. Do you want to save this as a draft?</h2>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="revertToDraft()"
          >
            Save Draft
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="draft=false"
          >
           No
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

<v-row justify="center" v-if="editMemory === true">
      <v-menu 
      top

    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          color="primary"
          class="m4u_text--text"
          v-bind="attrs"
          v-on="on"
        >
        Type
        <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title  @click="setType(1)" class="m4u_text--text">Memory</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(3)" class="m4u_text--text">Recipe</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(2)" class="m4u_text--text">Interview</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(4)" class="m4u_text--text">Tradition</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="idialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="mediaBtn"
        >            
         <v-icon class="m4u_text--text">mdi-image-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline m4u_text--text">Add Photo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
    <v-row no-gutters justify="center" align="center">
      <v-col cols="6">
    <div class="large-12 medium-12 small-12 cell">

        <input type="file" id="file" ref="file" class="m4u_text--text"  v-on:change="handleFileUpload()"/>

    </div>
      </v-col>
    </v-row>
    

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      
    </v-alert>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="cancelFileUpload()"
          >
            Cancel
          </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog  v-if="TypeDesc === 'Interview'"
      v-model="dialogi"
      scrollable
      max-width="600px"
    >

      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          class="m4u_text--text mb-4"
          v-bind="attrs"
          v-on="on"
          @click="getInterviews()"
         
        >
          <v-icon class="m4u_text--text">mdi-lightbulb-on-outline</v-icon>
        </v-btn>

      </template>


      <v-card>
        <v-card-title class="m4u_text--text">Interview Suggestions</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
<v-card
    class="mx-auto"
    max-width="500"
  >
    <v-list>
      <v-list-item-group v-model="selectedInterview">
        <v-list-item
          v-for="interview in interviews" :key="interview.InterviewID"
        >
          <v-list-item-content>
            <div class="suggestionDiv m4u_text--text">
            {{interview.IntQuestion}}
            </div>
          </v-list-item-content>
        </v-list-item>
                    <v-divider></v-divider>
      </v-list-item-group>
    </v-list>
  </v-card>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogi = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="setInterview()"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog  v-if="TypeDesc === 'Tradition'"
      v-model="dialogt"
      scrollable
      max-width="300px"
    >

      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="mb-4"
          dark
          v-bind="attrs"
          v-on="on"
          @click="getTraditions()"
        >
          <v-icon class="m4u_text--text">mdi-lightbulb-on-outline</v-icon>
        </v-btn>

      </template>


      <v-card>
        <v-card-title class="m4u_text--text">Tradition Suggestions</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
<v-card
    class="mx-auto"
    max-width="500"
  >
    <v-list>
      <v-list-item-group v-model="selectedTradition">
        <v-list-item
          v-for="tradition in traditions" :key="tradition.TraditionTypeID"
        >
          <v-list-item-content>
          <div class="suggestionDiv m4u_text--text">
            {{tradition.TraditionName}}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogt = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="setTradition()"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

<!-- END OF ADD MEDIA DIALOG -->


      <div v-if="editMemory === true">

              <!-- START OF MEDIA GALLERY -->
        <v-row wrap justify-center>
      <div v-for="media in medialocs" :key="media.MediaID" class="GalleryDiv"  >
      <div v-if="editMemory === true" >
      <MediaCard :mediaLocs="media.MediaLoc" :mediatype="media.MediaType" :mediaUser="user.UserID" :mediaFeature="media.FeatureMedia" :edit='true' @reloadMedia="resetMedia()"/>

      </div>
        </div>
        </v-row>

        <!-- <v-row> -->

          <v-form class="m4u_tertiary mt-4" >
      <v-row>
        <div style="width:75%;" class="ml-5">
          <v-progress-linear
            indeterminate
            color="teal"
            v-if="progressOn"
          ></v-progress-linear>
              <v-textarea v-if="toggle_exclusive !== 2 && toggle_exclusive !== 4 && editMemory === true" label="Title" color="m4u_text"
              v-model="storyData.StoryTitle" :rules="titleRules" auto-grow rows="2" rowHeight="10"></v-textarea>
        </div>
      </v-row>
      <v-row>
          <div style="width:75%;" class="ml-5">
              <v-textarea v-if="toggle_exclusive === 2 && editMemory === true" label="Interview Question" color="m4u_text"
              v-model="storyData.StoryTitle" :rules="titleRules" auto-grow rows="2" rowHeight="10"></v-textarea>
                </div>
      </v-row>
      <v-row>
          <div style="width:75%;" class="ml-5">
              <v-textarea v-if="toggle_exclusive === 2 && editMemory === true" label="Interviewee Name" color="m4u_text"
              v-model="storyData.Interviewee" :rules="titleRules" auto-grow rows="2" rowHeight="10"></v-textarea>        
              </div>
      </v-row>
        <v-row id="tradition" v-if="toggle_exclusive === 4">
          <div style="width:38rem;" class="mt-4 pl-2">
          <v-textarea v-if="toggle_exclusive === 4 && editMemory === true" label="Name a tradition" 
          auto-grow rows="2" rowHeight="10" color="m4u_text"
          v-model="storyData.StoryTitle" :rules="titleRules"></v-textarea>
          </div>
      </v-row>

          <v-row>
          <div style="width:75%;" class="ml-5">
              <v-textarea label="Ingredients" v-model="storyData.StoryIngredients" color="m4u_text"
              auto-grow rows="2" rowHeight="10"
              v-if="toggle_exclusive === 3 && editMemory === true"></v-textarea>
          </div>
          </v-row>
          <v-row>
          <div style="width:75%;" class="ml-5">
              <v-textarea label="Directions" v-model="storyData.StoryText" color="m4u_text"
              auto-grow rows="2" rowHeight="10"
              v-if="toggle_exclusive === 3 && editMemory === true"></v-textarea>
          </div>
          </v-row>
          <v-row>
          <div style="width:75%;" class="ml-5">
              <v-textarea label="Describe this memory" v-model="storyData.StoryText" color="m4u_text"
              auto-grow rows="2" rowHeight="10"
              v-if="toggle_exclusive !== 3 && editMemory === true"></v-textarea>
          </div>
          </v-row>
          <v-row>
          <div style="width:20rem;" class="ml-5">
              <v-select
              v-model="storyData.CircleID"
              :items="circles"
              label="Share with..."
              item-text="CircleName"
              item-value="CircleID"
              return-object
              required
              color="m4u_text"
              @change="getCircleID()"
              ></v-select>
          </div>
        <div class="ml-3">
          <v-checkbox
          v-model="storyData.Hidden"
          label="Share only in time capsules?"
          class="hide"
          color="m4u_text"
        ></v-checkbox>

        </div>
          </v-row>
          </v-form>

      </div>
      <div v-if="editMemory">
        <!-- <v-card-actions v-if="editMemory"> -->
            <v-row
        align="center"
        justify="space-around">


            <v-btn
            color="primary"
          dark
          class="teal--text text--accent-4"
            text
            icon
            large
            @click="draftCheck()"

          >
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-btn
            color="teal"
            dark
            text
            large
            v-on:click="revertToDraft()"
          >
          Save as Draft
          </v-btn>
          <v-btn
            color="primary"
            class="teal--text text--accent-4"
            dark
            text
            icon
            large
            v-on:click="cancelEdit()"
          >
          <v-icon>mdi-window-close</v-icon>
          </v-btn>
          </v-row>


        <!-- </v-card-actions> -->
        </div>
              <div class="primary m4u_text--text"  >
    <v-btn icon fab v-if="heartStatus === true" @click="changeHeartStatus()"><span v-if="heartTotal !== 0">{{heartTotal}}</span>
      <v-icon class="m4u_text_button--text text--accent-4">mdi-heart-multiple</v-icon></v-btn>
  <v-btn icon fab v-if="heartStatus !==  true"  @click="changeHeartStatus()"><span v-if="heartTotal !== 0">{{heartTotal}}</span>
    <v-icon>mdi-heart-multiple</v-icon></v-btn>
    <p  v-for="heart in heartList" :key="heart.UserID">{{heart.UserDisplayName}}</p>
  </div>
    </v-card-text>

            <v-card-actions>
             <v-btn v-if="user.UserID === storyData.Userid && editMemory===false" dark @click="editMemory=true" color="primary" mx-6 title="Edit Memory"> 
              <v-icon class="m4u_text--text">mdi-pencil-outline</v-icon></v-btn>

        <!--- START DIALOG FOR ADDING TO BOOKS --->
        <v-dialog
            v-model="dialog"
            scrollable
            max-width="50%"
            v-if="editMemory === false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
              title="Add Memory to a Book"
                class="m4u_text--text"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="m4u_text--text">mdi-book-open-blank-variant</v-icon>
              </v-btn>

            </template>
            <v-card >
              <v-card-title class="primary m4u_text--text">Select Books</v-card-title>
              <v-card-text v-if="books.length === 0" class="m4u_text--text">There are no more books to add this story to.</v-card-text>
              <v-divider></v-divider>
              <v-card-text style="height: 300px;">

              <v-checkbox 
              @click="updateBooks(book.BookID, book.BookStatus)"
              v-for="book in books" :key="book.BookID"
              v-model="book.BookStatus"
              color="m4u_text"
              class="m4u_text--text"
            :label="book.BookTitle"
            :value="book.BookStatus">
            </v-checkbox>

              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  class="teal--text text--accent-4"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>

        <!---END DIALOG FOR ADDING TO BOOKS --->
  <v-btn @click="backButton" class="teal--text m4u_tertiary" v-if="editMemory===false">CLOSE</v-btn>
      <v-spacer></v-spacer>
              </v-card-actions>
    <p v-if="storyData.Hidden === 1 && !editMemory" class="m4u_text--text">*shared only in time capsules</p>

    </v-card>
    </v-layout>
    </div>
</template>
<script>
import MediaCard from '../components/MediaCard';
import EventService from '@/services/EventService.js'; 

export default {
  name: 'memoryreader',
  props: 
    ['incomingStoryId']
  ,
  components: {
    MediaCard
  },
    data() {
    return {
      progressOn: false,
      editMemory: false,
      progressOn: false,
      toggle_exclusive: 1,
      TypeDesc: 'Memory',
       dialog: false,
      dialogtrad: '',
      dialogt: false,
      selectedTradition: '',
      dialoginterview: '',
      dialogi: false,
      selectedInterview: '',
      circles: [],
      setCircleID: '',
      draft: false,
      files: [],
      componentKey: '0',
      selected: '',
      draft: null,
      storyData: {
          StoryTypeID: '',
          StoryTitle: '',
          StoryText: '',
          CircleID: '',
          Memory: true,
          Recipe: false,
          Tradition: false,
          Interviewee: '',
          StoryIngredients: '',
          Hidden: false,
       },
       comments: [],
       heartTotal: 0,
       heartList: '',
       heartStatus: false,
       showHearts: false,
       updateType: '',
       CircleID: '',
       medialocs: [],
       mediaUpdates: true,
       currentFile: undefined,
      selectedFile: null,
      message: '',
      idialog: false,
      vdialog: false,
      file: '',
      storyID: '',
      titleRules: [
        v => !!v || 'This is required',
        v => (v && v.length >= 5) || 'Must be at least 5 characters',
      ],
     traditions: [],
      interviews: [],
      books: [],
      checkedBooks: [],
             predefinedBtnProps: {
          xs: {
            'x-small': true
          },
          sm: {
            'small': true
          },
          md: {
            
          },
          lg: {
            'large': true
          },
          xl: {
            'x-large': true
          }
        }
       }
    },


  mounted() {
    if (this.incomingStoryId)  {
          this.storyID = this.incomingStoryId
    } else 
  {
      this.storyID = this.$route.params.incomingStoryID 
    }
    this.getThisStory(this.storyID)
    this.editMemory = false;
    this.getMyCircles(this.user.UserID);
    this.setType(this.storyData.StoryTypeID);
    this.updateType = this.storyData.StoryTypeID;
    this.getMedia();
    this.getMyBooks();
    this.getComments();
    this.getHeartList();
    this.getHeartStatus();
  },

 computed: {
    user(){
    return this.$store.state.user
  },
    token(){
      return this.$store.state.token
    },

  refreshToken() {
    return this.$store.state.refreshToken
  },
  
  story(){
    return this.$store.state.story
  },
  
  loginState(){
    return this.$store.state.loginState
  }
  },

    btnProps()  {
  let props = {}
  switch(this.$vuetify.breakpoint.name) {
    case 'xs':
      props.color = 'blue'
      props['x-small'] = true
      break
    case 'sm':
      props.color = 'blue'
      props['small'] = true
      break  
    case 'lg':
      props.color = 'green'
      props['large'] = true
      break
      case 'xl':
      props.color = 'purple'
      props['x-large'] = true
      break 
    default: 
      props.color = 'red'
  }
  return props
        },


  methods: {
    backButton() {
      this.editMemory=false;
      this.$emit('closeReaderDialog')
    },

    getCircleID() {
      this.CircleID = this.storyData.CircleID.CircleID
    },

    async getMyCircles() {
      await EventService.getMyCircles(this.user.UserID)
      .then(
        (circles => {
          this.$set(this, "circles", circles);
        }).bind(this)

      );
    },

      async setType(sentStoryID) {

          if (sentStoryID === 1) {
            this.TypeDesc = 'Memory';
            this.updateType = 1  
            this.toggle_exclusive = 1 }
          if (sentStoryID === 2) {
            this.TypeDesc = 'Interview'; 
            this.updateType = 2
            this.toggle_exclusive = 2 }
          if (sentStoryID === 3) {
            this.TypeDesc = 'Recipe';
            this.updateType = 3
            this.toggle_exclusive = 3 }
          if (sentStoryID === 4) {
            this.TypeDesc = 'Tradition'; 
            this.updateType = 4
            this.toggle_exclusive = 4 }
      },

  async getThisStory() {
      EventService.getThisStory(this.storyID)
      .then(
        (stories => {
          this.$set(this, "storyData", stories[0]);
          if (this.storyData.Hidden === 1) {
            this.storyData.Hideen = true
          } else {this.storyData.Hidden = false}
            this.$store.dispatch('setStory', this.story);
            this.getMedia();
        }).bind(this)
      )
      .then(() => {
            this.setType(this.storyData.StoryTypeID);
          this.setCircleID = this.storyData.CircleID;
           this.CircleID = this.storyData.CircleID;
        this.setType(this.storyData.StoryTypeID);
        this.updateType = this.storyData.StoryTypeID;
      });
    
    },

        async getComments() {
          this.comments = '';
          await (EventService.getComments(this.incomingStoryId))
        .then(
        (comments => {
          this.$set(this, "comments", comments);
        }).bind(this) 
      );
        },

      async draftCheck() {
//        console.log('this.CircleID is: ', this.CircleID)
          if (this.CircleID === null || this.CircleID === 0 || this.CircleID === '') {
            this.draft = true;
          } else {
            this.updateMemory();
          }
      },
      
        async updateMemory() {

          this.progressOn = true;
        await (EventService.updateMemory(this.storyData, this.CircleID, this.updateType))
        .then(() => {this.progressOn = false})
        this.editMemory = false;
        this.$emit('memoryUpdate', this.storyData.StoryID)
        this.$emit('refreshList', this.storyData.StoryID)
        },

        async revertToDraft() {
          this.progressOn = true;
          this.draft = null;
        await (EventService.updateDraft(this.storyData, this.draft, this.updateType))
        .then(() => {this.progressOn = false})
        this.editMemory = false;
        this.$emit('memoryUpdate', this.storyData.StoryID)
        this.$emit('refreshList', this.storyData.StoryID)
        },
        
    async deleteComment(commentID) {
     await (EventService.deleteComment(commentID))
        .then(() => {
          this.getComments();
        })
    },

        async deleteMemory() {
        await (EventService.deleteMemory(this.storyData.StoryID))
        .then((returnDelete) => {})
        this.editMemory = false;
        this.$parent.$emit('memoriesChanged', false);    
        this.$parent.$emit('refreshList', true);    
        this.readerDialog = false;
        this.editMemory = false;
        },


        async resetMedia() {
          await (EventService.getMedia(this.storyData.StoryID))
        .then(
        (medialocs => {
          this.$set(this, "medialocs", medialocs);
        }).bind(this) 
      );
        },

        async getMedia() {
        await (EventService.getMedia(this.storyID))
        .then(
        (medialocs => {
          this.$set(this, "medialocs", medialocs);
        }).bind(this) 
      );
              
        },

            async getTraditions() {
        await (EventService.getTraditions())
        .then(
        (traditions => {
          this.$set(this, "traditions", traditions);
        }).bind(this) 
      );  
        },

          async getInterviews() {
        await (EventService.getInterviews())
        .then(
        (interviews => {
          this.$set(this, "interviews", interviews);
        }).bind(this) 
      );  
        },

    async setTradition() {
      this.dialogt = false;
      this.storyData.StoryTitle = this.traditions[this.selectedTradition].TraditionName
    },

    async setInterview() {
      this.dialogi = false;
      this.storyData.StoryTitle = this.interviews[this.selectedInterview].IntQuestion
    },
  
    async getHeartList() {
//      console.log('starting getHeartList, storyid, userid', this.storyID, this.user.UserID)
      await EventService.getHeartList(this.storyID, this.user.UserID)
      .then(
        (heartList => {
          this.heartTotal = heartList.output.heartTotal;
//          console.log('this.heartTotal', this.heartTotal)
          if(heartList.output.heartTotal !== 0) {
            // heartList.recordset.forEach((heart) => {
            //   this.heartList = heart
            // })
          this.$set(this, "heartList", heartList.recordset);
//          console.log('this.heartList is: ', this.heartList)
          } else {
            this.heartList = [];
          }
        }).bind(this)
      )
            .then (
        this.$nextTick(()=>{})
      )
    },

        async getHeartStatus() {
      await EventService.getHeartStatus(this.storyID, this.user.UserID)
      .then(
        (heartStatus => {
          if(heartStatus.recordset[0].HeartCount > 0) {
          this.$set(this, "heartStatus", true);
          } else {
            this.$set(this, "heartStatus", false);
          }

        }).bind(this)
      )
            .then (
        this.$nextTick(()=>{})
      )
    },


    async changeHeartStatus() {
    if(this.heartStatus === false){
      await EventService.addHeartStatus(this.storyID, this.user.UserID)
        .then(() => {
          this.getHeartStatus();
          this.getHeartList();
        })
      } else
     {
      await EventService.removeHeartStatus(this.storyID, this.user.UserID)
      .then(() => {
        this.getHeartStatus();
        this.getHeartList();
     })
     }
  },

      async updateBooks(bookID, bookStatus) {
      if (bookStatus === true) {
      await (EventService.addToBooks(bookID, this.storyID))
      .then(async () => {
        await this.getMyBooks()
      })
      }
      if (bookStatus === null || bookStatus === false) {
      await (EventService.removeFromBooks(bookID, this.storyID))
      .then(async () => {
        await this.getMyBooks()
      })
      }
      },


      async getMyBooks() {
      await (EventService.getBooksToAddStory(this.user.UserID, this.storyID))
        .then(
        (books => {
          this.$set(this, "books", books);
        }).bind(this) 
      )
      .then(
          () => {
            if(this.books === null) {
              this.noBookMsg = true;
            } 
          }
        )
      },


  async handleFileUpload(){
    this.file = this.$refs.file.files[0];
      this.idialog = false
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('userID', this.user.UserID);
      formData.append('storyID', this.storyData.StoryID);
      formData.append('reauthToken', this.$store.state.reauthToken)

      await (EventService.addNewBlob(formData))
      .then(() => {
            this.selectedFile = null;
      })
      .then(() => {
        this.resetMedia()
        this.$nextTick()
      })
  },

    async cancelFileUpload() {
        this.file = ''
        this.idialog = false

    },

    async cancelEdit() {
        this.getThisStory(this.storyID)
        this.CircleID = this.storyData.CircleID;
        this.setType(this.storyData.StoryTypeID)
        this.editMemory = false;

    }

  } 
}



</script>
<style lang="scss" scoped>

pre {
  overflow-x: auto;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
}

  .commentCard {
    justify-content: center;
  }
   .GalleryDiv {
     margin: 1.5em;
     max-width: 85%;
     justify-content: center;
   }

   .lookupDiv {
     display: inline-block;
   }

.mediaBtn {
    margin-left: 15px;
    margin-bottom: 15px;
}

.suggestionDiv {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: orange;
}
</style>